export default __webpack_public_path__ + "static/radovi2-df1137e213a03ddebf5d5979fe6cc034.png";